import { LegalDataDto } from "services/organizationBranch/restModels";

import {
    BANK_ACCOUNT_LENGTH,
    BIK_LENGTH,
    INN_LENGTH_COMPANY,
    INN_LENGTH_ENTREPRENEUR,
    KPP_LENGTH,
    OGRNIP_LENGTH,
    OGRN_LENGTH,
} from "features/Tariff/constants";
import { LegalDataFormField, LegalDataFormValues } from "features/Tariff/types";

export const EMPTY_LEGAL_DATA_FORM: LegalDataFormValues = {
    type: "RussianOOOCard",
    title: "",
    inn: "",
    kpp: "",
    ogrn: "",
    ogrnip: "",
    bankTitle: "",
    bankBik: "",
    bankCurrentAccountNumber: "",
    bankCorrespondentAccountNumber: "",
};

export const legalDataToForm = (legalData: LegalDataDto | null): LegalDataFormValues => {
    if (!legalData) return EMPTY_LEGAL_DATA_FORM;

    return {
        type: legalData.type,
        title: legalData.title,
        inn: legalData.inn,
        kpp: legalData.kpp || "",
        ogrn: legalData.ogrn || "",
        ogrnip: legalData.ogrnip || "",
        bankTitle: legalData.bankTitle,
        bankBik: legalData.bankBik,
        bankCurrentAccountNumber: legalData.bankCurrentAccountNumber,
        bankCorrespondentAccountNumber: legalData.bankCorrespondentAccountNumber,
    };
};

// Длина ИНН зависит от формы организации — единственное поле, у которого две нормы.
export const innLength = (type: LegalDataFormValues["type"]): number =>
    type === "RussianOOOCard" ? INN_LENGTH_COMPANY : INN_LENGTH_ENTREPRENEUR;

const digitsError = (value: string, length: number, label: string): string => {
    if (!value) return "";

    return value.length === length ? "" : `${label} — ${length} цифр`;
};

/*
* Проверки повторяют бэковые (LegalDataHandlers): форма не даёт отправить заведомо
* отказной запрос, но истина всё равно на бэке.
* */
export const legalDataFieldError = (
    form: LegalDataFormValues,
    field: LegalDataFormField
): string => {
    switch (field) {
        case "title":
            return "";
        case "inn":
            return digitsError(form.inn, innLength(form.type), "ИНН");
        case "kpp":
            return form.type === "RussianOOOCard"
                ? digitsError(form.kpp, KPP_LENGTH, "КПП")
                : "";
        case "ogrn":
            return form.type === "RussianOOOCard"
                ? digitsError(form.ogrn, OGRN_LENGTH, "ОГРН")
                : "";
        case "ogrnip":
            return form.type === "RussianIPCard"
                ? digitsError(form.ogrnip, OGRNIP_LENGTH, "ОГРНИП")
                : "";
        case "bankBik":
            return digitsError(form.bankBik, BIK_LENGTH, "БИК");
        case "bankCurrentAccountNumber":
            return digitsError(form.bankCurrentAccountNumber, BANK_ACCOUNT_LENGTH, "Расчётный счёт");
        case "bankCorrespondentAccountNumber":
            return digitsError(
                form.bankCorrespondentAccountNumber,
                BANK_ACCOUNT_LENGTH,
                "Корреспондентский счёт"
            );
        default:
            return "";
    }
};

export const isLegalDataFormValid = (form: LegalDataFormValues): boolean => {
    const requiredFilled =
        !!form.title.trim() &&
        !!form.bankTitle.trim() &&
        form.inn.length === innLength(form.type) &&
        form.bankBik.length === BIK_LENGTH &&
        form.bankCurrentAccountNumber.length === BANK_ACCOUNT_LENGTH &&
        form.bankCorrespondentAccountNumber.length === BANK_ACCOUNT_LENGTH &&
        (form.type === "RussianOOOCard"
            ? form.kpp.length === KPP_LENGTH && form.ogrn.length === OGRN_LENGTH
            : form.ogrnip.length === OGRNIP_LENGTH);

    return requiredFilled;
};
